/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const AzureIconConfig = {
  name: 'AzureIcon',
  height: 150,
  width: 160,
  svgPath: 'm88.33 0-47.66 41.33-40.67 73h36.67zm6.34 9.67-20.34 57.33 39 49-75.66 13h124z',
  yOffset: '-10',
  xOffset: '0',
  transform: ''
};
export default createIcon(AzureIconConfig);